module.exports = __webpack_public_path__ + "static/media/coverOne.61388b33.png";